import { render, staticRenderFns } from "./ClassStudentList.vue?vue&type=template&id=2f2ec39c&scoped=true&"
import script from "./ClassStudentList.vue?vue&type=script&lang=js&"
export * from "./ClassStudentList.vue?vue&type=script&lang=js&"
import style0 from "./ClassStudentList.vue?vue&type=style&index=0&id=2f2ec39c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2ec39c",
  null
  
)

export default component.exports